export enum SHAPES {
  ACTIVITY = 'activity',
  FLOWLINE = 'flowline',
  TEXTBOX = 'text'
}

export enum BORDER_STYLES {
  SOLID = 'solid',
  DASHED = 'dashed',
  DOTTED = 'dotted'
}

export enum STYLES {
  ARC_SIZE = 'arcSize',
  BACKGROUND_COLOR = 'backgroundColor',
  BORDER_COLOR = 'borderColor',
  BORDER_WIDTH = 'borderWidth',
  BORDER_STYLE = 'borderStyle',
  FONT = 'font',
  FONT_BOLD = 'fontBold',
  FONT_COLOR = 'fontColor',
  FONT_ITALIC = 'fontItalic',
  FONT_SIZE = 'fontSize',
  FONT_UNDERLINE = 'fontUnderline',
  HIDE_NUMBER = 'hideNumber',
  HORIZONTAL = 'horizontal',
  ICON_COLOR = 'iconColor',
  LENGTH = 'length',
  LINE_COLOR = 'lineColor',
  LINE_WIDTH = 'lineWidth',
  MAIN_COLOR = 'mainColor',
  NUMBER_COLOR = 'numberColor',
  NUMBER_ICON_COLOR = 'numberIconColor',
  SECONDARY_COLOR = 'secondaryColor',
  SHADOW = 'shadow',
  TEXT_ALIGN = 'textAlign',
  VERTICAL_ALIGN = 'verticalAlign',
  RESOURCES_STYLE = 'resourcesStyle',
  INFO_STYLE = 'infoStyle',
  UNDERLINE_COLOR = 'underlineColor'
}
